<header>
  <div class="header-logo">
    <span class="logo-text-green">國泰健康管理</span>
    <div class="logo-divider"></div>
    <span class="logo-sub">Happy Habit 每日衡好選</span>
  </div>
</header>

<main class="maintenance-container">
  <h1>系統修復中</h1>
  
  <div class="maintenance-msg">
    <h3>很抱歉，系統修復中，預計於{{ targetOpeningTime }}<br> 開放使用</h3>
    <p>如需協助請聯繫客服</p>
    <p class="tel-info">客服專線：{{ customerServicePhone }}</p>
  </div>
</main>